// have to create file in same directory: email.js
// the only 2 lines that go in email.js are:
// const email = "<my-email-here>";
// export default email;

const copyEmailButton = document.getElementById("copy-email-button");

const handleCopyEmail = (email) => {
  navigator.clipboard.writeText(email);
};

const addCopyEmailButtonListener = (email) => {
  copyEmailButton.addEventListener("click", () => handleCopyEmail(email));
};

export default addCopyEmailButtonListener;
